import data from './data'
import components from './components'
import mounted from './mounted'
import computed from './computed'
import methods from './methods'
import validations from './validations'

export default {
  computed,
  data,
  components,
  mounted,
  methods,
  validations,
  /* route API for professional prices */
  resourcePath: '/v1/professional/companies/prices'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/resources/index.js